import { combineReducers } from 'redux';
import trajectoryReducer from './entities/trajectory';

export default combineReducers({
  trajectory: trajectoryReducer,
});
